import React from 'react';
import { motion } from 'framer-motion';

export const Reveal = ({ children, delay = 0, y = 24, className = '' }) => {
    return (
        <motion.div
            className={className}
            initial={{ opacity: 0, y }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-80px' }}
            transition={{ duration: 1.0, delay, ease: [0.22, 1, 0.36, 1] }}
        >
            {children}
        </motion.div>
    );
};

export const RevealLine = ({ delay = 0, className = '', orientation = 'horizontal' }) => {
    const isVertical = orientation === 'vertical';
    return (
        <motion.div
            className={`bg-ink/20 ${className}`}
            style={{
                height: isVertical ? '100%' : '1px',
                width: isVertical ? '1px' : '100%',
                transformOrigin: isVertical ? 'top' : 'left center',
            }}
            initial={{ scaleX: isVertical ? 1 : 0, scaleY: isVertical ? 0 : 1 }}
            whileInView={{ scaleX: 1, scaleY: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 1.4, delay, ease: [0.22, 1, 0.36, 1] }}
        />
    );
};

export default Reveal;
